import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import chart from "../../Images/continuous-improvement.png";
import review from "../../Images/accountability.png";
import feedback from "../../Images/feedback-loop.png";
import goal from "../../Images/goal.png";
import TargetIcon from "@mui/icons-material/TrackChanges"; // for Active Goals
import GroupIcon from "@mui/icons-material/Group"; // for Team Members
import TrendingUpIcon from "@mui/icons-material/TrendingUp"; // for Completion Rate
import StarIcon from "@mui/icons-material/Star"; // for Avg Rating
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import history from "../../../../../history";

const stats = [
  {
    label: "Active Goals",
    value: "12",
    change: "+2.5%",
    icon: TargetIcon,
    color: "#3b82f6",
  },
  {
    label: "Team Members",
    value: "48",
    change: "+12%",
    icon: GroupIcon,
    color: "#10b981",
  },
  {
    label: "Achievement Percentage",
    value: "87%",
    change: "+5.2%",
    icon: TrendingUpIcon,
    color: "#8b5cf6",
  },
  {
    label: "Avg Rating",
    value: "4.8",
    change: "+0.3",
    icon: StarIcon,
    color: "#f59e0b",
  },
];

const DashboardActionPage = ({ setCurrentMode }) => {
  return (
    <Box>
      <Grid container spacing={1} sx={{ mb: 2 }}>
        {stats?.map((stat, index) => (
          <Grid item xs={12} sm={6} lg={3} key={index}>
            <Card
              elevation={0}
              sx={{
                background: "#f3edfd",
                backdropFilter: "blur(10px)",
              }}
            >
              <CardContent
                sx={{ pt: 2, pb: 0, px: 3 }}
              >
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Box>
                    <Typography
                      variant="body1"
                      gutterBottom
                      sx={{ fontWeight: 600, color: "inherit" }}
                    >
                      {stat.label}
                    </Typography>
                    <Typography variant="h4" fontWeight="bold" sx={{ my: 1 }}>
                      {stat.value}
                    </Typography>
                    <Typography variant="body2" color="success.main">
                      {stat.change}
                    </Typography>
                  </Box>
                  <stat.icon size={24} sx={{ color: stat.color }} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Card sx={{ display: "flex" }}>
        <Grid container spacing={1}>
          <Grid item xs={7} md={9}>
            <CardContent
              sx={{
                padding: "16px",
                backgroundColor: "#f3edfd",
              }}
            >
              <Grid
                container
                spacing={3}
                sx={{ justifyContent: "center", alignItems: "center" }}
              >
                {/* Manage Goals */}
                <Grid item xs={12} md={6}>
                  <Box
                    className="quick-action-pms"
                    onClick={() => history.push("/performance-management/goals")}
                  >
                    <div
                      className="quick-app-name-pms"
                      style={{ marginBottom: "5px", width: "100%" }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "start",
                          width: "100%",
                        }}
                      >
                         <div className="quick-app-icon-pms">
                          <img src={goal} alt="chart" />
                        </div>
                        <KeyboardArrowRightIcon
                        color="primary"
                          sx={{ mt: "5px" }}
                        />
                      </Box>
                      <Typography variant="h6" color="inherit">
                        Manage Goals
                      </Typography>
                      <Typography variant="body1" color="inherit">
                        Set, track and update team objectives
                      </Typography>
                    </div>
                  </Box>
                </Grid>

                {/* Continuous Feedback */}
                <Grid item xs={12} md={6}>
                  <Box
                    className="quick-action-pms"
                    onClick={() => history.push("/performance-management/feedback")}
                  >
                    <div
                      className="quick-app-name-pms"
                      style={{ marginBottom: "5px", width: "100%" }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "start",
                          width: "100%",
                        }}
                      >
                         <div className="quick-app-icon-pms">
                          <img src={feedback} alt="chart" />
                        </div>
                        
                        <KeyboardArrowRightIcon
                        color="primary"
                          sx={{ mt: "5px" }}
                        />
                      </Box>
                      <Typography variant="h6" color="inherit">
                        Continuous Feedback
                      </Typography>
                      <Typography variant="body1" color="inherit">
                        Provide and receive real-time feedback
                      </Typography>
                    </div>
                  </Box>
                </Grid>

                {/* Continuous Performance */}
                <Grid item xs={12} md={6}>
                  <Box className="quick-action-pms"
                    onClick={() => history.push("/performance-management/performance")}
                  >
                    <div
                      className="quick-app-name-pms"
                      style={{ marginBottom: "5px", width: "100%" }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "start",
                          width: "100%",
                        }}
                      >
                        <div className="quick-app-icon-pms">
                          <img src={chart} alt="chart" />
                        </div>
                        <KeyboardArrowRightIcon
                        color="primary"
                          sx={{ mt: "5px" }}
                        />
                      </Box>
                      <Typography variant="h6" color="inherit">
                        Continuous Performance
                      </Typography>
                      <Typography variant="body1" color="inherit">
                        View detailed performance metrics
                      </Typography>
                    </div>
                  </Box>
                </Grid>

                {/* Review */}
                <Grid item xs={12} md={6}>
                  <Box className="quick-action-pms" 
                       onClick={() => history.push("/performance-management/review")}
                  >
                    <div
                      className="quick-app-name-pms"
                      style={{ marginBottom: "5px", width: "100%" }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "start",
                          width: "100%",
                        }}
                      >
                        <div className="quick-app-icon-pms">
                          <img src={review} alt="review" />
                        </div>
                        <KeyboardArrowRightIcon
                        color="primary"
                          sx={{ mt: "5px" }}
                        />
                      </Box>
                      <Typography variant="h6" color="inherit">
                        Review
                      </Typography>
                      <Typography variant="body1" color="inherit">
                        Conduct and manage performance reviews
                      </Typography>
                    </div>
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Grid>
          <Grid item xs={5} md={3}>
            <CardContent sx={{height: "100%", border: "1px solid #98a3ac", borderRadius: "10px"}}>
              <Box >Recent Activity</Box>
              <Box sx={{ fontWeight: 600, color: "#555", height: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>Coming Soon</Box>
            </CardContent>
          </Grid>
        </Grid>
      </Card>
    </Box>
  );
};

export default DashboardActionPage;
